import { render, staticRenderFns } from "./main.vue?vue&type=template&id=597a2d0a"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=597a2d0a&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('597a2d0a')) {
      api.createRecord('597a2d0a', component.options)
    } else {
      api.reload('597a2d0a', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=597a2d0a", function () {
      api.rerender('597a2d0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/dashboard/Tablebox/main.vue"
export default component.exports